"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FlowStore_1 = __importDefault(require("CreatePageFlow/FlowStore"));
var FlowController_1 = __importDefault(require("CreatePageFlow/FlowController"));
var IntegrationConfiguration_1 = __importDefault(require("@CommonFrontend/CreatePageFlow/steps/IntegrationConfiguration"));
var PreLoad_1 = __importDefault(require("CreatePageFlow/steps/PreLoad"));
var ObjectSelection_1 = __importDefault(require("CreatePageFlow/steps/ObjectSelection"));
var TemplateSelection_1 = __importDefault(require("CreatePageFlow/steps/TemplateSelection"));
var PreBake_1 = __importDefault(require("CreatePageFlow/steps/PreBake"));
var Creating_1 = __importDefault(require("CreatePageFlow/steps/Creating"));
var Success_1 = __importDefault(require("CreatePageFlow/steps/Success"));
var ApiService_1 = require("CreatePageFlow/ApiService");
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var CreatePageTelemetry_1 = __importDefault(require("./CreatePageTelemetry"));
var types_1 = require("./types");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var TokenForm_1 = __importDefault(require("./steps/TokenForm"));
var utils_1 = require("./utils");
var validateInput = function (origin) {
    switch (origin.source) {
        case types_1.CreatePageFlowSource.Crm:
            if (!("integrationName" in origin && "objectType" in origin && "objectId" in origin)) {
                throw new Error("Some inputs are missing for the in-CRM experience");
            }
            if (!Types_1.PLATFORM_SUPPORTED_PROVIDER_TYPES.has(origin.integrationName)) {
                throw new Error("Integration not supported");
            }
            break;
        case types_1.CreatePageFlowSource.Qwilr:
            if (!("templateId" in origin)) {
                throw new Error("Template id is missing for the in-app experience");
            }
            break;
        default:
            throw new Error("Unexpected flow origin");
    }
};
exports.default = (function (_a) {
    var apiBaseUrl = _a.apiBaseUrl, accountId = _a.accountId, telemetry = _a.telemetry, prompts = _a.prompts, closeButtonHandler = _a.closeButtonHandler, flowOrigin = _a.flowOrigin, tokenList = _a.tokenList, serverTelemetry = _a.serverTelemetry;
    validateInput(flowOrigin);
    var apiService = new ApiService_1.ApiService(apiBaseUrl, accountId);
    var cpaTelemetry = new CreatePageTelemetry_1.default(telemetry, serverTelemetry);
    var steps;
    var flowStore;
    if (flowOrigin.source === types_1.CreatePageFlowSource.Qwilr) {
        var templateId = flowOrigin.templateId;
        if (flowOrigin.integrationName && (0, utils_1.isPlatformSupportedIntegration)(flowOrigin.integrationName)) {
            cpaTelemetry.createPageInitiatedFromQwilr(templateId);
            flowStore = new FlowStore_1.default({ apiService: apiService, prompts: prompts, templateId: templateId });
            steps = [
                { id: "preLoad", component: PreLoad_1.default, excludeNavigation: true },
                { id: "integrationConfiguration", component: IntegrationConfiguration_1.default, excludeNavigation: true },
                { id: "objectSelection", component: ObjectSelection_1.default },
                { id: "preBake", component: PreBake_1.default },
                { id: "creating", component: Creating_1.default, excludeNavigation: true },
                { id: "success", component: Success_1.default, excludeNavigation: true },
            ];
        }
        else {
            flowStore = new FlowStore_1.default({ apiService: apiService, templateId: templateId, tokenList: tokenList });
            steps =
                (tokenList === null || tokenList === void 0 ? void 0 : tokenList.length) === 0
                    ? [
                        { id: "preLoad", component: PreLoad_1.default, excludeNavigation: true },
                        { id: "preBake", component: PreBake_1.default },
                        { id: "creating", component: Creating_1.default, excludeNavigation: true },
                    ]
                    : [
                        { id: "preLoad", component: PreLoad_1.default, excludeNavigation: true },
                        { id: "tokenForm", component: TokenForm_1.default },
                        { id: "preBake", component: PreBake_1.default },
                        { id: "creating", component: Creating_1.default, excludeNavigation: true },
                    ];
        }
    }
    else {
        var integrationName = flowOrigin.integrationName, objectType = flowOrigin.objectType, objectId = flowOrigin.objectId;
        cpaTelemetry.createPageInitiatedFromCrm(integrationName, objectType, objectId);
        flowStore = new FlowStore_1.default({ apiService: apiService, prompts: prompts, integrationName: integrationName, objectType: objectType, objectId: objectId });
        steps = [
            { id: "preLoad", component: PreLoad_1.default, excludeNavigation: true },
            { id: "integrationConfiguration", component: IntegrationConfiguration_1.default, excludeNavigation: true },
            { id: "templateSelection", component: TemplateSelection_1.default },
            { id: "preBake", component: PreBake_1.default },
            { id: "creating", component: Creating_1.default, excludeNavigation: true },
            { id: "success", component: Success_1.default, excludeNavigation: true },
        ];
    }
    return (react_1.default.createElement(DIProvider_1.default, { container: function () {
            var container = new inversify_1.Container();
            container.bind(ApiService_1.ApiService).toConstantValue(apiService);
            container.bind(CreatePageTelemetry_1.default).toConstantValue(cpaTelemetry);
            return container;
        } },
        react_1.default.createElement(FlowController_1.default, { store: flowStore, steps: steps, closeButtonHandler: closeButtonHandler, flowSource: flowOrigin.source })));
});
